/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditAuditFacets200,
  AuditAuditLogParams,
  AuditCellHistoryParams,
  AuditPage,
  AuditRecentEditsParams,
  AuditRow,
  HTTPValidationError,
  OperationRow,
  RecentEdit,
  UndoPreview
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAuditAuditLogUrl = (params?: AuditAuditLogParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/audit?${stringifiedParams}` : `/api/v1/audit`
}

/**
 * @summary The change log, newest first (keyset paging)
 */
export const auditAuditLog = async (params?: AuditAuditLogParams, options?: Parameters<typeof apiFetch>[1]): Promise<AuditPage> => {

  return apiFetch<AuditPage>(getAuditAuditLogUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditAuditLogQueryKey = (params?: AuditAuditLogParams,) => {
    return [
    `/api/v1/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof auditAuditLog>>, TError = HTTPValidationError>(params?: AuditAuditLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditLog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditAuditLogQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditAuditLog>>> = ({ signal }) => auditAuditLog(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditAuditLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof auditAuditLog>>>
export type AuditAuditLogQueryError = HTTPValidationError


export function useAuditAuditLog<TData = Awaited<ReturnType<typeof auditAuditLog>>, TError = HTTPValidationError>(
 params: undefined |  AuditAuditLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditAuditLog>>,
          TError,
          Awaited<ReturnType<typeof auditAuditLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditAuditLog<TData = Awaited<ReturnType<typeof auditAuditLog>>, TError = HTTPValidationError>(
 params?: AuditAuditLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditAuditLog>>,
          TError,
          Awaited<ReturnType<typeof auditAuditLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditAuditLog<TData = Awaited<ReturnType<typeof auditAuditLog>>, TError = HTTPValidationError>(
 params?: AuditAuditLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditLog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The change log, newest first (keyset paging)
 */

export function useAuditAuditLog<TData = Awaited<ReturnType<typeof auditAuditLog>>, TError = HTTPValidationError>(
 params?: AuditAuditLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditLog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditAuditLogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditAuditFacetsUrl = () => {




  return `/api/v1/audit/facets`
}

/**
 * @summary Users and tables that appear in the change log (filter options)
 */
export const auditAuditFacets = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AuditAuditFacets200> => {

  return apiFetch<AuditAuditFacets200>(getAuditAuditFacetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditAuditFacetsQueryKey = () => {
    return [
    `/api/v1/audit/facets`
    ] as const;
    }


export const getAuditAuditFacetsQueryOptions = <TData = Awaited<ReturnType<typeof auditAuditFacets>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditFacets>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditAuditFacetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditAuditFacets>>> = ({ signal }) => auditAuditFacets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditAuditFacets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditAuditFacetsQueryResult = NonNullable<Awaited<ReturnType<typeof auditAuditFacets>>>
export type AuditAuditFacetsQueryError = unknown


export function useAuditAuditFacets<TData = Awaited<ReturnType<typeof auditAuditFacets>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditFacets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditAuditFacets>>,
          TError,
          Awaited<ReturnType<typeof auditAuditFacets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditAuditFacets<TData = Awaited<ReturnType<typeof auditAuditFacets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditFacets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditAuditFacets>>,
          TError,
          Awaited<ReturnType<typeof auditAuditFacets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditAuditFacets<TData = Awaited<ReturnType<typeof auditAuditFacets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditFacets>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Users and tables that appear in the change log (filter options)
 */

export function useAuditAuditFacets<TData = Awaited<ReturnType<typeof auditAuditFacets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditAuditFacets>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditAuditFacetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditCellHistoryUrl = (params: AuditCellHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/audit/history?${stringifiedParams}` : `/api/v1/audit/history`
}

/**
 * @summary History of one row, or of one cell of it
 */
export const auditCellHistory = async (params: AuditCellHistoryParams, options?: Parameters<typeof apiFetch>[1]): Promise<AuditRow[]> => {

  return apiFetch<AuditRow[]>(getAuditCellHistoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditCellHistoryQueryKey = (params?: AuditCellHistoryParams,) => {
    return [
    `/api/v1/audit/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditCellHistoryQueryOptions = <TData = Awaited<ReturnType<typeof auditCellHistory>>, TError = HTTPValidationError>(params: AuditCellHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditCellHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditCellHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditCellHistory>>> = ({ signal }) => auditCellHistory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditCellHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditCellHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof auditCellHistory>>>
export type AuditCellHistoryQueryError = HTTPValidationError


export function useAuditCellHistory<TData = Awaited<ReturnType<typeof auditCellHistory>>, TError = HTTPValidationError>(
 params: AuditCellHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditCellHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditCellHistory>>,
          TError,
          Awaited<ReturnType<typeof auditCellHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditCellHistory<TData = Awaited<ReturnType<typeof auditCellHistory>>, TError = HTTPValidationError>(
 params: AuditCellHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditCellHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditCellHistory>>,
          TError,
          Awaited<ReturnType<typeof auditCellHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditCellHistory<TData = Awaited<ReturnType<typeof auditCellHistory>>, TError = HTTPValidationError>(
 params: AuditCellHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditCellHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary History of one row, or of one cell of it
 */

export function useAuditCellHistory<TData = Awaited<ReturnType<typeof auditCellHistory>>, TError = HTTPValidationError>(
 params: AuditCellHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditCellHistory>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditCellHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditRecentEditsUrl = (params: AuditRecentEditsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["table"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/audit/recent?${stringifiedParams}` : `/api/v1/audit/recent`
}

/**
 * @summary Cells people typed lately in these tables: by whom, and what they held before
 */
export const auditRecentEdits = async (params: AuditRecentEditsParams, options?: Parameters<typeof apiFetch>[1]): Promise<RecentEdit[]> => {

  return apiFetch<RecentEdit[]>(getAuditRecentEditsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditRecentEditsQueryKey = (params?: AuditRecentEditsParams,) => {
    return [
    `/api/v1/audit/recent`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditRecentEditsQueryOptions = <TData = Awaited<ReturnType<typeof auditRecentEdits>>, TError = HTTPValidationError>(params: AuditRecentEditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditRecentEdits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditRecentEditsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditRecentEdits>>> = ({ signal }) => auditRecentEdits(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditRecentEdits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditRecentEditsQueryResult = NonNullable<Awaited<ReturnType<typeof auditRecentEdits>>>
export type AuditRecentEditsQueryError = HTTPValidationError


export function useAuditRecentEdits<TData = Awaited<ReturnType<typeof auditRecentEdits>>, TError = HTTPValidationError>(
 params: AuditRecentEditsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditRecentEdits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditRecentEdits>>,
          TError,
          Awaited<ReturnType<typeof auditRecentEdits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditRecentEdits<TData = Awaited<ReturnType<typeof auditRecentEdits>>, TError = HTTPValidationError>(
 params: AuditRecentEditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditRecentEdits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditRecentEdits>>,
          TError,
          Awaited<ReturnType<typeof auditRecentEdits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditRecentEdits<TData = Awaited<ReturnType<typeof auditRecentEdits>>, TError = HTTPValidationError>(
 params: AuditRecentEditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditRecentEdits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cells people typed lately in these tables: by whom, and what they held before
 */

export function useAuditRecentEdits<TData = Awaited<ReturnType<typeof auditRecentEdits>>, TError = HTTPValidationError>(
 params: AuditRecentEditsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditRecentEdits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditRecentEditsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditOperationsUrl = () => {




  return `/api/v1/operations`
}

/**
 * @summary Operations that can be undone (selection, crossing, numbering, merge…)
 */
export const auditOperations = async ( options?: Parameters<typeof apiFetch>[1]): Promise<OperationRow[]> => {

  return apiFetch<OperationRow[]>(getAuditOperationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditOperationsQueryKey = () => {
    return [
    `/api/v1/operations`
    ] as const;
    }


export const getAuditOperationsQueryOptions = <TData = Awaited<ReturnType<typeof auditOperations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditOperations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditOperationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditOperations>>> = ({ signal }) => auditOperations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditOperations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof auditOperations>>>
export type AuditOperationsQueryError = unknown


export function useAuditOperations<TData = Awaited<ReturnType<typeof auditOperations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditOperations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditOperations>>,
          TError,
          Awaited<ReturnType<typeof auditOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditOperations<TData = Awaited<ReturnType<typeof auditOperations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditOperations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditOperations>>,
          TError,
          Awaited<ReturnType<typeof auditOperations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditOperations<TData = Awaited<ReturnType<typeof auditOperations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditOperations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Operations that can be undone (selection, crossing, numbering, merge…)
 */

export function useAuditOperations<TData = Awaited<ReturnType<typeof auditOperations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditOperations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditOperationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditUndoPreviewUrl = (opId: string,) => {




  return `/api/v1/operations/${opId}/undo`
}

/**
 * @summary What undoing an operation would change, and what blocks it
 */
export const auditUndoPreview = async (opId: string, options?: Parameters<typeof apiFetch>[1]): Promise<UndoPreview> => {

  return apiFetch<UndoPreview>(getAuditUndoPreviewUrl(opId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditUndoPreviewQueryKey = (opId: string,) => {
    return [
    `/api/v1/operations/${opId}/undo`
    ] as const;
    }


export const getAuditUndoPreviewQueryOptions = <TData = Awaited<ReturnType<typeof auditUndoPreview>>, TError = HTTPValidationError>(opId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditUndoPreview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditUndoPreviewQueryKey(opId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditUndoPreview>>> = ({ signal }) => auditUndoPreview(opId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: opId !== null && opId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditUndoPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditUndoPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof auditUndoPreview>>>
export type AuditUndoPreviewQueryError = HTTPValidationError


export function useAuditUndoPreview<TData = Awaited<ReturnType<typeof auditUndoPreview>>, TError = HTTPValidationError>(
 opId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditUndoPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditUndoPreview>>,
          TError,
          Awaited<ReturnType<typeof auditUndoPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditUndoPreview<TData = Awaited<ReturnType<typeof auditUndoPreview>>, TError = HTTPValidationError>(
 opId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditUndoPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditUndoPreview>>,
          TError,
          Awaited<ReturnType<typeof auditUndoPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditUndoPreview<TData = Awaited<ReturnType<typeof auditUndoPreview>>, TError = HTTPValidationError>(
 opId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditUndoPreview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What undoing an operation would change, and what blocks it
 */

export function useAuditUndoPreview<TData = Awaited<ReturnType<typeof auditUndoPreview>>, TError = HTTPValidationError>(
 opId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditUndoPreview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditUndoPreviewQueryOptions(opId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAuditUndoUrl = (opId: string,) => {




  return `/api/v1/operations/${opId}/undo`
}

/**
 * @summary Undo an operation (one transaction)
 */
export const auditUndo = async (opId: string, options?: Parameters<typeof apiFetch>[1]): Promise<UndoPreview> => {

  return apiFetch<UndoPreview>(getAuditUndoUrl(opId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAuditUndoMutationKey = () => ['auditUndo'] as const;

export const getAuditUndoMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof auditUndo>>, TError,AuditUndoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof auditUndo>>, TError,AuditUndoMutationVariables, TContext> => {

const mutationKey = getAuditUndoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof auditUndo>>, AuditUndoMutationVariables> = (props) => {
          const {opId} = props ?? {};

          return  auditUndo(opId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuditUndoMutationResult = NonNullable<Awaited<ReturnType<typeof auditUndo>>>

    export type AuditUndoMutationError = HTTPValidationError
    export type AuditUndoMutationVariables = {opId: string}

    /**
 * @summary Undo an operation (one transaction)
 */
export const useAuditUndo = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof auditUndo>>, TError,AuditUndoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof auditUndo>>,
        TError,
        AuditUndoMutationVariables,
        TContext
      > => {
      return useMutation(getAuditUndoMutationOptions(options), queryClient);
    }
